var _style, _polyline, _ellipse, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalControlKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.9,5.6 7.9,15.5 0.6,15.5 2.6,5.6 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 4.3,
    cy: 3.3,
    rx: 2.7,
    ry: 2.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.2,
    y1: 6.2,
    x2: 7.7,
    y2: 6.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 6.2,
    x2: 10.4,
    y2: 6.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.5,
    y1: 6.2,
    x2: 13,
    y2: 6.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 6.2,
    x2: 15.6,
    y2: 6.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalControlKey);
export default __webpack_public_path__ + "static/media/MechanicalControlKey.5ec964ed2afcae7c8bb900562537cc53.svg";
export { ForwardRef as ReactComponent };